import { render } from "./EditKnowledge.vue?vue&type=template&id=db7f8c00"
import script from "./EditKnowledge.vue?vue&type=script&lang=js"
export * from "./EditKnowledge.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__